<template>
  <div class="bulkUpdate">
    <operateButton :button-config="buttonConfig"></operateButton>
    <Collapse v-model="collapseShow">
      <Panel name="1">
        导入信息
        <Form
          slot="content"
          ref="formValidate"
          :model="formValidate"
          :rules="ruleValidate"
          :label-width="110"
        >
          <Row>
            <Col span="9">
              <FormItem label="选择导入模版" prop="url">
                <Select v-model="formValidate.url">
                  <Option v-for="(item, i) in modleList" :value="item.url" :key="i">{{ item.name }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="7">
              <FormItem label prop>
                <Button type="primary" @click="downloadModel">下载模版</Button>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="附件上传" prop="upload">
                <input
                  type="file"
                  id="file"
                  name="file"
                  accept=".xls, .xlsx"
                  @change="fileChange($event)"
                />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
    </Collapse>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>
<script>
import axios from "axios";
import operateButton from "commonCrumb/components/tabsComponent/operateButton.vue";
export default {
  data() {
    return {
      spinShow: false,
      buttonConfig: {
        buttons: [
          {
            text: "导入",
            icon: "",
            btnClick: () => {
              this.check();
            }
          },
          {
            text: "返回",
            icon: "",
            btnClick: () => {
              this.$store.commit("global/tabCloseAppoint", {
                tableName: "CL_C_BATCH_UPDATE",
                routeFullPath: this.$route.path
              });
            }
          }
        ]
      },
      userId: "",
      modleList: [],
      collapseShow: "1",
      formValidate: {
        url: "",
        upload: ""
      },
      ruleValidate: {
        url: [
          {
            required: true,
            message: "请选择导入模版！",
            trigger: "change"
          }
        ],
        upload: [
          {
            required: true,
            message: "",
            trigger: "blur"
          }
        ]
      },
      type: -1
    };
  },
  components: {
    operateButton
  },
  mounted() {
    this.userId = JSON.parse(window.localStorage.getItem("userInfo")).id;
    let a = location.href;
    this.id = a.split("/")[a.split("/").length - 1];
    this.getFileUrl();
  },
  methods: {
    getFileUrl() {
      axios({
        url: "/p/cs/scrm/getFileUrl",
        method: "POST",
        data: {}
      }).then(({ data }) => {
        if (data.data.code == 0) {
          this.modleList = data.data.message;
          return;
        }
        this.$Message.error(data.data.message);
      });
    },
    downloadModel() {
      if (!this.formValidate.url) {
        this.$Message.error("请选择导入模版！");
        return;
      }
      window.location.href = this.formValidate.url;
    },
    fileChange(ev) {
      console.log("ev::", ev);
    },
    check() {
      let fle = document.getElementById("file").files[0];
      if (!fle) {
        this.$Message.error("请选择文件！");
        return;
      }
      this.modleList.map(item => {
        if (item.url == this.formValidate.url) {
          this.type =
            item.url == this.formValidate.url ? Number(item.code) : this.type;
        }
      });
      if (this.type == -1) {
        this.$Message.error("请选择导入模版！");
        return;
      }
      let formData = new FormData();
      formData.append("file", fle, fle.name);
      formData.append("type", this.type);
      this.spinShow = true;
      axios({
        url: "/p/cs/scrm/check",
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data;boundary=" + new Date().getTime()
        }
      })
        .then(({ data }) => {
          if (data.code == 0) {
            this.spinShow = false
            this.$Message.success(data.message);
            // this.$Message.success({
            //   content: data.message,
            //   duration: 10
            // });
            document.getElementById('file').value = '';
            return;
          }
        })
        .catch((error) => {console.log(error); this.spinShow=false});
    }
  }
};
</script>
<style lang="less" scoped>
html {
  width: 100%;
  height: 100%;
}
.bulkUpdate {
  width: 100%;
  height: 100%;
}
</style>